import React from 'react';
import { TextFilter, DateRangeFilter, EnumFilter } from './FilterComponents.js';

const TableFilterPopover = ({
  activeFilter,
  processedColumns,
  filterValues,
  filterHeaderRefs,
  onChange,
  onClose,
}) => {
  if (!activeFilter.isOpen || !activeFilter.columnKey) {
    return null;
  }

  const { columnKey, type } = activeFilter;
  const column = processedColumns.find(col => col.key === columnKey);
  if (!column) return null;

  const currentValue = filterValues[columnKey];
  const columnIndex = processedColumns.findIndex(col => col.key === columnKey);
  const alignRight = columnIndex >= processedColumns.length - 2;
  const getAnchorEl = () => filterHeaderRefs.current[columnKey];

  const filterProps = {
    onChange,
    onClose,
    getAnchorEl,
    alignRight,
  };

  switch (type) {
    case 'text':
      return (
        <TextFilter
          {...filterProps}
          value={currentValue || ''}
        />
      );
    case 'date':
      return (
        <DateRangeFilter
          {...filterProps}
          value={currentValue || { startDate: '', endDate: '' }}
        />
      );
    case 'enum':
      return (
        <EnumFilter
          {...filterProps}
          value={currentValue || {}}
          enumOptions={column.enumOptions}
        />
      );
    default:
      return null;
  }
};

export default TableFilterPopover;
